import type { AccessLevel, FeatureAccess } from "@fortex/api";
import type { ForteXMapConfig } from "@fortex/map";
import { grantedLevel, uiFeatures } from "../auth/store";

export type Can = (feature: string, level: Exclude<AccessLevel, "None">) => boolean;

export type MapFeatureConfig = Required<Pick<ForteXMapConfig, "controls" | "info">>;

export function canOfGrants(features: FeatureAccess[]): Can {
  const access: Record<string, AccessLevel> = {};

  for (const item of features) access[item.feature] = item.accessLevel;

  return (feature, level) => grantedLevel(access, feature, level);
}

export function mapControlsFor(can: Can, searchLayers: string[] | null = null, searchLabel: string | null = null): MapFeatureConfig {
  const on = (feature: string) => can(feature, "ReadOnly");

  return {
    controls: {
      miniMap: on(uiFeatures.miniMap),
      rail: false,
      drawToolbar: false,
      search: on(uiFeatures.search) ? { address: false, layers: searchLayers, label: searchLabel } : false,
      layersTab: on(uiFeatures.layers),
      drawer: true,
      table: on(uiFeatures.grid),
      route: on(uiFeatures.route),
      measure: on(uiFeatures.measure),
      locate: on(uiFeatures.locate),
      coordinates: on(uiFeatures.coordinates),
      legend: on(uiFeatures.legend)
    },
    info: {
      enabled: on(uiFeatures.detail),
      pictures: on(uiFeatures.photos)
    }
  };
}
